export enum ProfileMSDI {
  ProfileApiService = 'ProfileApiService',
  ProfileQueryLayerService = 'ProfileQueryLayerService',
  ProfileQueryKeysService = 'ProfileQueryKeysService',
  ProfileModel = 'ProfileModel',
  ProfileController = 'ProfileController',
}
